module.exports = __webpack_public_path__ + "d81d5376e09703aa8e85dce47e4d52cd.svg";